import React from "react"
import CardHowItWork from '../../../components/CardHowItWork'
import ArrowBack from '../../../components/ArrowBack'

import { ContainerWrapper, ContainerCards } from './styles'

import img1 from '../../../assets/ImagesRetailerGuide/image-1.png'
import img2 from '../../../assets/ImagesRetailerGuide/image-2.png'
import img3 from '../../../assets/ImagesRetailerGuide/image-3.png'
import img4 from '../../../assets/ImagesRetailerGuide/image-4.png'
import img5 from '../../../assets/ImagesRetailerGuide/image-5.png'
import img6 from '../../../assets/ImagesRetailerGuide/image-6.png'


function RetailerGuide() {

    const returnElements = [
        {
            id: 1,
            title: "1° passo - Crie sua conta de Revendedor",
            phrases: ["Preencha seus dados pessoais e crie seu cadastro", "Faça o login em sua conta"],
            image: img1
        },

        {
            id: 2,
            title: "2° passo - Preencha seus dados bancários",
            phrases: ["Após isso seu cadastro estará completo"],
            image: img2
        },

        {
            id: 3,
            title: "3° passo - Acesse sua Área do Revendedor",
            phrases: ["Veja seu perfil e informações contidas nele"],
            image: img3
        },

        {
            id: 4,
            title: "4° passo - Convide novos usuários para Ir de Férias",
            phrases: ["Salve o QRCode ou o link", "Compartilhe por meio de sua rede social preferida"],
            image: img4
        },
        {
            id: 5,
            title: "5° passo - Acompanhe seu relatório de revendas",
            phrases: ["Confiras a comissão adquirida por cada revenda", "Navegue suas revendas pelo período"],
            image: img5
        },
        {
            id: 6,
            title: "6° passo - Receba seu comissionamento acumulado!",
            phrases: ["Aproveite as funcionalidades"],
            image: img6
        }
    ]

    return(
        <>
            <ArrowBack/>
            <ContainerWrapper>
                <div className="header-style">
                    <h1>Guia Revendedor</h1>
                    <p>"Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                    accusantium doloremque laudantium, totam rem aperiam, eaque
                    natus error sit voluptatem
                    accusantium doloremque laudantium, totam rem aperiam</p>
                </div>
                    <ContainerCards>
                        {returnElements?.map((element) => (
                            <CardHowItWork
                                key={element.id}
                                title={element.title}
                                description={element.phrases}
                                image={element.image}
                            />
                        ))}
                    </ContainerCards>
            </ContainerWrapper>
        </>
    )
}

export default RetailerGuide